import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/common/Breadcrum'
import ServerTable from '../../components/table/ServerTable';
import { fetchCallCollections, callNotesHistoryByPhone } from '../../redux/slices/callCollectionSlice';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';

import Models from '../../components/common/Models';


import Select from '../../components/form/Select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';

export default function AdminCounselorsCalls() {
      const dispatch = useDispatch();
  const navigate = useNavigate();
const [dateRange, setDateRange] = useState([new Date(), null]);
  const [startDate, endDate] = dateRange;
  const [dateFilter, setDateFilter] = useState("today"); // New filter state
  const [activeCallType, setActiveCallType] = useState("ALL"); // Default to "All" call type
  const [searchTerm, setSearchTerm] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [tableRow, setTableRow] = useState([]);
const breadcrumbItems = [
     { label: 'Counselors Calls', path: '/admin/counselors' }   ,
    { label: 'Calls History', path: '/employee/calls-history' }
  ];
const callTypes = [
    {id:0,name:"All",value:"ALL"},
    {id:1,name:"Incoming",value:"INCOMING"},
    {id:2,name:"Outgoing",value:"OUTGOING"},
    {id:3,name:"Missed",value:"MISSED"},
  ]
    const dateFilterOptions = [
    {id:0,name:"Today",value:"today"},
    {id:1,name:"This Week",value:"week"},
    {id:2,name:"Custom Range",value:"custom"},
  ]
    const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1); // Reset page to 1 when filter changes
    if (filter !== 'custom') {
      const newRange = getDateRangeForFilter(filter);
      setDateRange(newRange);
    }
  };
   const getDateRangeForFilter = (filter) => {
      const today = moment();
      switch(filter) {
        case 'today':
          return [today.toDate(), today.toDate()];
        case 'week':
          const startOfWeek = today.clone().startOf('week');
          const endOfWeek = today.clone().endOf('week');
          return [startOfWeek.toDate(), endOfWeek.toDate()];
        case 'custom':
          return dateRange;
        default:
          return [today.toDate(), today.toDate()];
      }
    };
      const tableColumns = [
    { id: 'phone', label: 'Phone', type: 'text' },
    { id: 'name', label: 'Name', type: 'text' },
    {id:"types", label:"Call", type:"text"},
    { id: 'duration', label: 'Duration', type: 'text' },
    { id: 'time', label: 'Time', type: 'date' },
    { id: 'date', label: 'Date', type: 'date' },
     {
            id: "action",
            label: "Action",
            type: "action",
            actions: ["view"],
          }, // Placeholder for actions column
  ]

    const { data, total, loading, error, callNotes, callNotesLoading } = useSelector(state => state.callCollections);

    
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  };
   const handleTableAction = (action, row) => {
       console.log("Action:", action, "Row:", row);
       switch (action) {
            case 'view':
              navigate(`/admin/counselors/calls-details/${row.phone}`);
                break;
              case 'Add Remarks':
              setOpen(true);
              setCurrentRow(row);
              break;
            default:
           console.log("Unhandled action:", action);
        }
   };
   useEffect(() => {
         const todayRange = getDateRangeForFilter("today");
         setDateRange(todayRange);
       }, []);
   
     // Initialize with today's date range
     useEffect(() => {
       const todayRange = getDateRangeForFilter("today");
       setDateRange(todayRange);
     }, []);
     const location = useLocation()
       useEffect(() => {
         const currentRange = getDateRangeForFilter(dateFilter);
         const formattedStartDate = currentRange[0] ? moment(currentRange[0]).format('YYYY-MM-DD') : '';
         const formattedEndDate = currentRange[1] ? moment(currentRange[1]).format('YYYY-MM-DD') : '';
         
         dispatch(fetchCallCollections({
           page: currentPage,
           limit: rowsPerPage,
           search: searchTerm,
           callType: activeCallType === "ALL" ? "" : activeCallType,
           startDate: formattedStartDate,
           endDate: formattedEndDate,
           employeeId:location.pathname.split('/').pop() // Get the employee ID from the URL
         }));
       }, [dispatch, currentPage, rowsPerPage, searchTerm, activeCallType, dateFilter, dateRange, location.pathname]);

       
       
         useEffect(() => {
          
            if (data.length > 0) {
                 const updatedRows = data.map((call, index) => ({
                   uuid:call.id, 
                   id: index + 1,
                   phone:call.number,
                   name:call.callName,
                   remarks: call.callCollectionDetails[0]?.callRemarks || '', // Assuming callRemarks is the field for remarks
                   types: call.callType, // Assuming callType is the field for call type
                   duration: moment.utc(call.callDuration * 1000).format('HH:mm:ss'), // Convert seconds to HH:mm:ss format
                   time:moment(Number(call.callTimeStamp)).format('hh:mm:ss A'),  // 12-hour format with AM/PM
                   date: (() => {
                     const callDate = moment(Number(call.callTimeStamp));
                     const today = moment();
                     const yesterday = moment().subtract(1, 'day');
                     
                     if (callDate.isSame(today, 'day')) {
                       return 'Today';
                     } else if (callDate.isSame(yesterday, 'day')) {
                       return 'Yesterday';
                     } else {
                       return callDate.format('YYYY-MM-DD');
                     }
                   })(), // Show Today, Yesterday, or date
                 }));
                 setTableRow(updatedRows);
               }else{
                 setTableRow([]);
               }
         }, [data, currentPage, rowsPerPage, searchTerm]);
  return (
    <>
       <div className='bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center'>
            <div>
              <h1 className='text-2xl font-semibold text-theme-dark dark:text-theme-light'>{breadcrumbItems[0].label}</h1>
              <Breadcrum items={breadcrumbItems} />
            </div>
            <div className='flex justify-end items-center gap-3 relative z-[2]'>
              {/* Call Type Filter */}
              <div className='flex justify-end items-center gap-3'>
                <Select
                  options={callTypes.map(type => ({ value: type.value, label: type.name }))}
                  value={callTypes.find(type => type.value === activeCallType)?.value}
                  onChange={(selected) => setActiveCallType(selected)}
                />
              </div>
              
              {/* Date Filter Dropdown */}
              <div className='flex justify-end items-center gap-3'>
                <Select
                  options={dateFilterOptions.map(option => ({ value: option.value, label: option.name }))}
                  value={dateFilter}
                  onChange={(selected) => handleDateFilterChange(selected)}
                />
              </div>
              
              {/* Custom Date Picker - Only show when Custom is selected */}
              {dateFilter === 'custom' && (
                <div className='flex justify-end items-center gap-3'>
                  <DatePicker
                    className='p-3 rounded-lg border border-gray-300'
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      if(update[0] != null){
                        setDateRange(update);
                        setCurrentPage(1); // Reset page to 1 when custom date changes
                      }
                    }}
                    isClearable={true}
                    placeholderText="Select date range"
                  />
                </div>
              )}
            </div>
          </div>
            <div className='mt-4'>
                  <ServerTable
                    tableColumns={tableColumns}
                    title="Call History"
                    data={tableRow}
                    total={total}
                    loading={loading}
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[10, 25, 50]}
                    searchTerm={searchTerm}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                      handleTableAction={handleTableAction}
                  />
                  {error && <div className="text-red-500 mt-2">{error}</div>}
                </div>
    </>
  )
}
